export const locale = {
  lang: "en-CA",
  data: {
    ORDER_UPSALE: {
      TITLE: "Suggestions (upsell)",
      FOR_PRODUCT: "For product",
      EMPTY: "No suggestion for this product.",
      ADD: "Add to order",
      ADDED: "Added to order",
      ADD_ERROR: "Unable to add the item — please retry.",
      MATERIAL: "Material",
      PRODUCT: "Product",
    },
  },
};
